import React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';

const LearnMore = () => {
  const [t] = useTranslation('senderProfile');
  return (
    <a
      href="https://help.textinchurch.com/en/articles/7670784-sender-profile-us-accounts-only"
      target="_blank"
    >
      <Paper variant="outlined">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          p={1}
          px={2}
        >
          <Typography>
            {t('learn-more', 'Learn more about A2P 10-DLC')}
          </Typography>
          <ChevronRightIcon color="inherit" />
        </Stack>
      </Paper>
    </a>
  );
};

export default LearnMore;
